import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui's standard class-merge helper.
 * Combines clsx conditional logic with tailwind-merge dedupe/override rules.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
